import { render, staticRenderFns } from "./MtipocargaForm.vue?vue&type=template&id=7c54e885"
import script from "./MtipocargaForm.vue?vue&type=script&lang=js"
export * from "./MtipocargaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports